import * as React from 'react';
import throttle from 'lodash/throttle';

const BOTTOM_DISTANCE = 100;

const useInifiniteScroll = (
  ref: React.MutableRefObject<HTMLDivElement | null>,
  params?: {
    load: () => Promise<any>;
    hasMore: boolean;
    itemsLength?: number;
  }
) => {
  const [isAchieveBottom, setAchieveBottom] = React.useState<boolean>(false);

  const isBottomReached = React.useCallback((): boolean => {
    if (!ref.current) {
      return false;
    }

    const el = ref.current;

    return el.scrollHeight - el.scrollTop < el.clientHeight + BOTTOM_DISTANCE;
  }, [ref]);

  React.useEffect(() => {
    if (!ref.current || !params) {
      return;
    }

    const handler = throttle(() => {
      if (!ref.current) {
        return;
      }

      if (isBottomReached()) {
        setAchieveBottom(true);
      } else {
        setAchieveBottom(false);
      }
    }, 500);

    ref.current.addEventListener('scroll', handler);

    return () => {
      if (!ref.current || !params) {
        return;
      }

      ref.current.removeEventListener('scroll', handler);
    };
  }, [isBottomReached, params, ref]);

  React.useEffect(() => {
    if (!params) {
      return;
    }

    if (params.hasMore && isBottomReached()) {
      setAchieveBottom(true);
    }
  }, [isBottomReached, params?.hasMore, params?.itemsLength]);

  React.useEffect(() => {
    if (!params) {
      return;
    }

    if (params.hasMore && isAchieveBottom) {
      params.load();
    }
  }, [isAchieveBottom, params]);
};

export default useInifiniteScroll;
